export const environment = {
  production: false,
  baseUrl: 'https://api-staging.aris360.com/api/',
  mainBaseUrl: 'https://api-staging.aris360.com/',

  assestsBaseUrl: 'https://aris360storage.blob.core.windows.net/media-files/',
  fallBackImageUrl: 'assets/img/house-placeholder.jpg',
  dropZoneImageUploadUrl:
    'https://api-staging.aris360.com/api/Property/Listing/UploadImage',



  // Google OAuth Configuration
  googleClientId:
    '1010224631804-64a6sgk4u9ejvs4jh0r9qnta6vfodtuh.apps.googleusercontent.com',
  // NOTE: an unused googleClientSecret was removed from here. A client secret must
  // never ship in a browser bundle. It is still in git history, so ROTATE it in the
  // Google Cloud console — deleting it here does not invalidate the leaked value.

  // Apple OAuth Configuration
  appleServiceId: 'com.aris360.app',
  appleTeamId: '837V68QU3D',
  appleBundleId: 'com.aris360.aris360',

  // Legacy Google Auth Provider ID (keeping for backward compatibility)
  googleAuthProviderId:
    '636336131453-fke5n03jaah6gus9hi6j3l7odlt0gke6.apps.googleusercontent.com ',
  auth0Domain: 'dev-5cvlld3pfr2rm4ro.us.auth0.com',
  auth0ClientId: 'IRWO20SM4be7V2u43Fb9PhNyrqoflIaV',
  webUrl: 'https://www.staging.aris360.com/',
  gtmId: 'GTM-NV6DS9X7',

  //stripe keys
  //live key
  // stripePublishableKey:
  //   'pk_live_51MFRMVL17OecadNY4vpDIlxDmZTws4MbiwEFRTmYI9iD0XOdS8t6s6vZuioMaPRRqvd28NhTz3CP556NHm1mZwTX00uNYKT1gU',
  //test key
  stripePublishableKey:
    'pk_test_51MFRMVL17OecadNYedzjcj3cDejchzH8HTkSFsFzrg6NGQELxqhrvY9NsjCvB8yNFHKovPtPKVx0P7pDTsZg9FeI002EkWd97A',
  turnstileSiteKey: '0x4AAAAAADnsmCVSeeDEA0wB',
};
